import { useState } from 'react';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { Banner, Stack, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { Target } from '@mews/enums';
import { PayoutDetailSummary } from '@mews-commander/data-access';
import { EnterpriseLink } from '@mews-commander/ui';

interface PayoutReportDetailBannerProps {
    payoutDetailSummary: PayoutDetailSummary;
}

export const PayoutReportDetailBanner = ({ payoutDetailSummary }: PayoutReportDetailBannerProps) => {
    const [isBannerVisible, setIsBannerVisible] = useState(true);
    if (!isBannerVisible) {
        return null;
    }

    const supportPageLinkValue = createGuideLink(ArticlePath.PayoutReportDetail);
    const getSupportPageLinkElement = (text: string) => (
        <a href={supportPageLinkValue} target={Target.Blank} rel="noreferrer" aria-label="Support Page">
            <Typography textStyle="bodyMediumStrong" as="span">
                {text}
            </Typography>
        </a>
    );

    const getOriginalPayoutLink = (text: string) => {
        if (payoutDetailSummary?.isNestedPayout && payoutDetailSummary?.payoutTransactionId) {
            return (
                <Typography textStyle="bodyMediumStrong" as="span">
                    <EnterpriseLink
                        target={Target.Blank}
                        variant="basic"
                        to="PayoutReport/Detail/$id"
                        params={{
                            id: payoutDetailSummary.payoutTransactionId,
                        }}
                    >
                        {text}
                    </EnterpriseLink>
                </Typography>
            );
        }

        return text;
    };

    return (
        isBannerVisible && (
            <>
                <Banner
                    variant="info"
                    onClose={() => setIsBannerVisible(false)}
                    primaryText={
                        <Typography textStyle="bodyMediumStrong" as="div">
                            <LocalizedText textKey={TextKey.PayoutDetailStripeManualPayoutBannerTitle} />
                        </Typography>
                    }
                    secondaryText={
                        <Stack vertical>
                            <LocalizedText textKey={TextKey.PayoutDetailStripeManualPayoutBannerBodyPart1} />
                            <LocalizedText
                                textKey={TextKey.PayoutDetailStripeManualPayoutBannerBodyPart2}
                                substitutes={{
                                    originalPayoutLink: (text) => getOriginalPayoutLink(text as string),
                                    supportPageLink: (text) => getSupportPageLinkElement(text as string),
                                }}
                            />
                        </Stack>
                    }
                />
            </>
        )
    );
};
